import OptimizerEditDto from "./OptimizerEditDto";

export class BayesianOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {number} */
        this.epsilon = null;
    }

    /**
     * @typedef {Object} _BayesianOptimizerEditDtoProps
     * @property {number} epsilon
     * 
     * @typedef {import('./OptimizerEditDto').OptimizerEditDtoProps & _BayesianOptimizerEditDtoProps} BayesianOptimizerEditDtoProps
     */
    /**
     * 
     * @param {BayesianOptimizerEditDtoProps} props
     * @returns {BayesianOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);

        this.epsilon = props.epsilon;
        return this;
    }
}

export default BayesianOptimizerEditDto;